// Typeahead experiments
export const HA_TYPEAHEAD_LID_SEARCH = 'HA_TYPEAHEAD_LID_SEARCH';
